document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia("(max-width: 989px)").matches) {
        const coCollectionList = document.querySelector('.co-section-shop-filters--collections-list');
        const coCollectionTrigger = document.querySelector('.co-section-shop-filters--collections--trigger');

        if (coCollectionList) {
            // const list = container.querySelector('ul'); // adjust if needed

            const coCollectionItems = coCollectionList.querySelectorAll('li');

            // function checkListFit() {
            //     const last = coCollectionItems[coCollectionItems.length - 1];
            //     const lastRect = last.getBoundingClientRect();
            //     const containerRect = coCollectionList.getBoundingClientRect();

            //     // small tolerance to avoid off-by-a-pixel issues
            //     const tolerance = 1;
            //     const reached = lastRect.right >= (containerRect.right);

            //     // const reached = lastItemRight >= containerRight;
            //     // console.log('Reached container width:', reached);
            //     // return reached;
            //     console.log('Last item reached edge:', reached);

            //     if (reached) {
            //         coCollectionList.classList.add('overflown');
            //         coCollectionTrigger.classList.add('shown');
            //     }
            // }
            coCollectionList.classList.add('overflown');
            coCollectionTrigger.classList.add('shown');

            // checkListFit();
        }

        if (coCollectionTrigger) {
            if (coCollectionTrigger.classList.contains('shown')) {
                coCollectionTrigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    this.classList.toggle('active');

                    coCollectionList.classList.toggle('active');
                });

                // remove active if clicking outside
                document.addEventListener('click', (e) => {
                    const clickedInsideTrigger = coCollectionTrigger.contains(e.target);
                    const clickedInsideList = coCollectionList.contains(e.target);

                    if (!clickedInsideTrigger && !clickedInsideList) {
                        coCollectionTrigger.classList.remove('active');
                        coCollectionList.classList.remove('active');
                    }
                })
            }
        }
    }

    const swiper = new Swiper('.co-home-s3--slider', {
        // Default parameters
        slidesPerView: 4,
        spaceBetween: 24,
        loop: true,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.7,
                spaceBetween: 12
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 3,
                spaceBetween: 24
            },
            // when window width is >= 640px
            769: {
                slidesPerView: 4,
                spaceBetween: 24
            }
        }
    })
});